import React, { FC } from 'react'
import { Text, Checkbox, useCheckboxState, Flex, csx } from '@vtex/admin-ui'
import { ClickableArea } from '../ProductSummary'
import { useProductContext } from '../context'
import { getItemPayload } from '@/checkout-instore-legacy/utils/ProductUtils'
import { ItemPayload } from '@/checkout-instore-legacy/cart/message/types'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

export interface ServiceInterface {
  id: string
  allowGiftMessage: boolean
  name: string
  price: number
  type: string
  attachmentOfferings: []
}

export interface ProductServiceOptionsProps {
  services?: Array<ServiceInterface>
  changeOffering: (
    selectedServices: Array<string>,
    offeringId: number,
    itemPayload: ItemPayload
  ) => void
  bundleItems: Array<string>
}

const DEFAULT_OFFERING_NAME = 'embalagem para presente'

const ProductServiceOptions: FC<ProductServiceOptionsProps> = ({
  services,
  changeOffering,
  bundleItems,
}) => {
  const {
    value: selectedServices,
    setValue: setSelectedServices,
  } = useCheckboxState({ initialValue: bundleItems })
  const { item } = useProductContext()
  const itemPayload = getItemPayload(item)

  const handleOnchange = (serviceId: number) => {
    if (Array.isArray(selectedServices)) {
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Pick<Item, "ean" | "id" | "index" | "quantity" | "seller" | "bundleItems"... Remove this comment to see the full error message
      changeOffering(selectedServices, serviceId, itemPayload)
    }
  }

  const mountServices = () => {
    if (services === undefined) return <></>
    const filteredServices = services.map((service: any) => {
      if (
        service.name.toLowerCase() === DEFAULT_OFFERING_NAME || // TODO: implement all services cases and remove this
        service.name === getInstoreConfig().giftPackagingName
      ) {
        return (
          <ClickableArea key={service.id}>
            <Flex>
              <Checkbox
                data-testid="offering-checkbox"
                aria-label="label"
                state={{
                  value: selectedServices,
                  setValue: setSelectedServices,
                }}
                className={csx({
                  marginRight: '$space-2',
                  ':checked': {
                    background: '$action.main.primary',
                    ':hover': {
                      background: '$action.main.primaryHover',
                    },
                  },
                })}
                value={service.id}
                onChange={() => handleOnchange(service.id)}
              />
              <Text
                variant="detail"
                className={csx({ paddingTop: '$space-05' })}
              >
                {service.name}
              </Text>
            </Flex>
          </ClickableArea>
        )
      }
      return
    })
    return filteredServices
  }

  return (
    <div
      className={csx({
        marginTop: '$space-1',
        marginBottom: '$space-1',
        marginRight: '$space-4',
      })}
    >
      {mountServices()}
    </div>
  )
}

export default ProductServiceOptions
